import { render, staticRenderFns } from "./StreakInProfileStatistics.vue?vue&type=template&id=6b0ec892&scoped=true&"
import script from "./StreakInProfileStatistics.vue?vue&type=script&lang=js&"
export * from "./StreakInProfileStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StreakInProfileStatistics.vue?vue&type=style&index=0&id=6b0ec892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ec892",
  null
  
)

export default component.exports